import type { Transition, Variants } from 'framer-motion';

export const SPRING_DEFAULT: Transition = {
  type: 'spring',
  stiffness: 280,
  damping: 28,
};

export const SPRING_SNAP: Transition = {
  type: 'spring',
  stiffness: 300,
  damping: 30,
};

export const SPRING_SOFT: Transition = {
  type: 'spring',
  stiffness: 220,
  damping: 30,
};

/** Stagger reveal for word-by-word headlines. */
export const wordContainer: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.055, delayChildren: 0.1 },
  },
};

export const wordChild: Variants = {
  hidden: { y: 20, opacity: 0 },
  show: { y: 0, opacity: 1, transition: SPRING_DEFAULT },
};

/** Lists / link reveals — 40–60ms feel. */
export const listContainer: Variants = {
  hidden: {},
  show: { transition: { staggerChildren: 0.05, delayChildren: 0.05 } },
};

export const listChild: Variants = {
  hidden: { y: 12, opacity: 0 },
  show: { y: 0, opacity: 1, transition: SPRING_DEFAULT },
};
